import "slick-carousel";
import { resizeBackgroundImages } from "../../js/utilities/responsive-images";

/**
 * Initialize product slider
 * @param  {String} slider - Main product slider selector
 * @param  {String} thumbs - Thumbs product slider selector
 * @return {Void}
 */

export const init = (
  slider = ".js-product-slider",
  thumbs = ".js-product-slider-thumbs"
) => {
  const config = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow: $(slider).find(".js-slider-prev"),
    nextArrow: $(slider).find(".js-slider-next"),
    infinite: false,
    adaptiveHeight: false,
    lazyLoad: "ondemand",
    asNavFor: $(thumbs).find(".js-product-slider-thumbs-slides"),
  };

  let thumbSlidesToShow = 1;
  let thumbSlidesToScroll = 1;

  if (
    $(".js-product-slider-thumbs-slides").find(".responsive-background-image")
      .length < 6
  ) {
    thumbSlidesToShow = 6;
    thumbSlidesToScroll = 6;
  }

  const thumbsConfig = {
    slidesToShow: thumbSlidesToShow,
    slidesToScroll: thumbSlidesToScroll,
    dots: false,
    arrows: true,
    infinite: false,
    asNavFor: $(slider).find(".js-product-slider-slides"),
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true,
    prevArrow: $(thumbs).find(".js-slider-prev"),
    nextArrow: $(thumbs).find(".js-slider-next"),
  };

  $(slider)
    .find(".js-product-slider-slides")
    .not(".slick-initialized")
    .slick(config);
  $(slider).on("afterChange", function () {
    const targetImages = document.querySelectorAll(
      ".js-responsive-background-image"
    );
    resizeBackgroundImages(targetImages);
  });
  $(thumbs)
    .find(".js-product-slider-thumbs-slides")
    .not(".slick-initialized")
    .slick(thumbsConfig);
  $(thumbs).on("afterChange", function () {
    const targetImages = document.querySelectorAll(
      ".js-responsive-background-image"
    );
    resizeBackgroundImages(targetImages);
  });
};

init();

$(window).on("shopify:section:load", function (event) {
  init();
});
